import { post, get, wordpost, geted, postJson } from '../network/index.js'
const authType = data => {
  return post('/mercWebi/wxAuthorizerInfo/toBind', data)
}
const goDetail = data => {
  return post('/mercWebi/wxAuthorizerInfo/detail', data)
}
//绑定微信公众号
const wxAuthorizerInfobind = data => {
  return post('/mercWebi/wxAuthorizerInfo/bind', data)
}
//详细信息
const wxAuthorizerInfodetail = data => {
  return post('/mercWebi/wxAuthorizerInfo/detail', data)
}
//获取跳转绑定微信公众号页面
const wxAuthorizerInfotoBind = data => {
  return post('/mercWebi/wxAuthorizerInfo/toBind', data)
}
//获取解绑验证码
const getUnbindCode = data => {
  return post('/mercWebi/wxAuthorizerInfo/getUnbindCode', data)
}
//微信解绑
const unbind = data => {
  return post('/mercWebi/wxAuthorizerInfo/unbind', data)
}
//提交审核
const submitAudit = data => {
  return post('/mercWebi/wxAppAudit/submitAudit', data)
}
//检查审核结果
const checkAudit = data => {
  return post('/mercWebi/wxAppAudit/checkAudit', data)
}
//检查审核结果
const release = data => {
  return post('/mercWebi/wxAppAudit/release', data)
}
//短信条数
const queryCnt = data => {
  return post('/mercWebi/smsInfo/queryCnt', data)
}
//短信推送记录
const querySmsList = data => {
  return post('/mercWebi/smsInfo/queryList', data)
}
// 短信推送设置列表
const smsSettingListByPage = data => {
  return post('/mercWebi/smsInfo/smsSettingListByPage', data)
}
// 短信推送设置
const updateSmsSetting = data => {
  return post('/mercWebi/smsInfo/updateSmsSetting', data)
}

//查询外送配置
const queryDelivery = data => {
  return post('/mercWebi/busStoreInfo/queryDelivery', data)
}

//更新外送配置
const updateDelivery = data => {
  return post('/mercWebi/busStoreInfo/updateDelivery', data)
}

//查询外送区域列表
const queryRegionList = data => {
  return post('/mercWebi/busStoreInfo/queryRegionList', data)
}
//绘制外送区域
const addRegion = data => {
  return post('/mercWebi/busStoreInfo/addRegion', data)
}

//删除外送区域
const delRegion = data => {
  return post('/mercWebi/busStoreInfo/delRegion', data)
}

//新增关联跑腿员
const addWorker = data => {
  return post('/mercWebi/busStoreInfo/addWorker', data)
}

//关联跑腿员列表
const queryWorkerList = data => {
  return post('/mercWebi/busStoreInfo/queryWorkerList', data)
}

//跑腿员选择列表
const sysWorkerList = data => {
  return post('/mercWebi/busStoreInfo/sysWorkerList', data)
}

//删除关联跑腿员
const delWorker = data => {
  return post('/mercWebi/busStoreInfo/delWorker', data)
}
//查询优惠券列表
const queryCouponList = data => {
  return post('/mercWebi/couponInfo/queryList', data)
}
//优惠券版本列表
const VersionList = data => {
  return post('/mercWebi/couponInfo/queryVersionList', data)
}
//新建优惠券
const addCoupon = data => {
  return post('/mercWebi/couponInfo/addCoupon', data)
}
//编辑优惠券
const editCoupon = data => {
  return post('/mercWebi/couponInfo/editCoupon', data)
}
//优惠券详情
const queryCouponDetail = data => {
  return post('/mercWebi/couponInfo/queryDetail', data)
}
//优惠券详情
const queryCount = data => {
  return post('/mercWebi/couponInfo/queryCount', data)
}
//优惠券包列表
const queryPack = data => {
  return post('/mercWebi/couponInfo/queryPackageList', data)
}
//新建优惠券包
const addPack = data => {
  return post('/mercWebi/couponInfo/addPackage', data)
}
//编辑优惠券包
const updatePack = data => {
  return post('/mercWebi/couponInfo/updatePackage', data)
}
//修改优惠券包状态
const addPackStatus = data => {
  return post('/mercWebi/couponInfo/updatePackageStatus', data)
}
//券包详情
const PackageDetail = data => {
  return post('/mercWebi/couponInfo/queryPackageDetail', data)
}
//作废优惠券
const cancellationUserCoupon = data => {
  return post('/mercWebi/userInfo/userCouponStatus', data)
}

//新增营销活动
const addActivity = data => {
  return post('/mercWebi/busMercActivity/add', data)
}
//查询详情
const queryActivityDetail = data => {
  return post('/mercWebi/busMercActivity/queryDetail', data)
}
//列表营销活动
const queryActivityList = data => {
  return post('/mercWebi/busMercActivity/queryList', data)
}
//编辑营销活动
const updateActivity = data => {
  return post('/mercWebi/busMercActivity/update', data)
}

// 修改营销活动状态
const updateStatus = data => {
  return post('/mercWebi/busMercActivity/updateStatus', data)
}
// 修改优惠券状态
const updateCouponStatus = data => {
  return post('/mercWebi/couponInfo/updateStatus', data)
}

// 新增营销活动
const addMercActivity = data => {
  return post('/mercWebi/busMercActivity/add', data)
}

// 店铺选择列表
const selectStoreList = data => {
  return post('/mercWebi/busStoreInfo/selectList', data)
}
// 参与活动用户统计列表
const participantList = data => {
  return post('/mercWebi/busMercActivity/participantList', data)
}
// 参与活动用户统计列表
const participantStatistic = data => {
  return post('/mercWebi/busMercActivity/participantStatistic', data)
}
// 被邀请人列表
const inviteeList = data => {
  return post('/mercWebi/busMercActivity/inviteeList', data)
}
// 拼团管理 - 分页查询拼团列表
const listPartakeInfo = data => {
  return post('/sWebi/swPartake/listPartakeInfo', data)
}

// 拼团管理 - 分页查询组团列表
const listClusterInfo = data => {
  return post('/sWebi/swPartake/listClusterInfo', data)
}

// 拼团管理 - 新增拼团信息
const insertPartake = data => {
  return post('/sWebi/swPartake/insertPartake', data)
}

// 拼团管理 - 根据拼团id获取拼团详情
const partakeDetail = data => {
  return get('/sWebi/swPartake/listPartakeById', data)
}

// 拼团管理 - 修改拼团信息
const updatePartake = data => {
  return post('/sWebi/swPartake/updatePartake', data)
}

// 拼团管理 - 统计拼团数量
const countPartakeInfo = data => {
  return post('/sWebi/swPartake/countPartakeInfo', data)
}

// 拼团管理 - 统计组团数量
const countClusterInfo = data => {
  return post('/sWebi/swPartake/countClusterInfo', data)
}
// 广告投送 - 新增广告
const insertAdvertise = data => {
  return post('/mercWebi/webAdvertise/insertAdvertise', data)
}
// 广告投送 - 修改广告
const modifyAdvertise = data => {
  return post('/mercWebi/webAdvertise/modifyAdvertise', data)
}
// 广告投送 - 修改广告状态
const modifyStatus = data => {
  return post('/mercWebi/webAdvertise/modifyAdvertiseStatus', data)
}
// 广告投送 - 获取广告位置列表
const listAdvertisePosition = data => {
  return post('/mercWebi/webAdvertise/listAdvertisePosition', data)
}
// 广告投送 - 获取广告列表
const listAdvertise = data => {
  return post('/mercWebi/webAdvertise/listAdvertise', data)
}
// 广告投送 - 根据分站id获取店铺
const listStoreByStationId = data => {
  return get('/sWebi/webAdvertise/listStoreByStationId', data)
}
// 广告投送 - 删除广告
const deleteAdvertise = data => {
  return get('/mercWebi/webAdvertise/deleteAdvertise', data)
}
// 广告投送 - 广告明细
const advertiseDetail = data => {
  return get('/mercWebi/webAdvertise/listAdvertiseById', data)
}
// 广告投送-位置上移下移
const moveAdvertise = data => {
  return post('/mercWebi/webAdvertise/moveAdvertise', data)
}

const updateWxappParam = data => {
  return post('/mercWebi/mercInfo/updateWxappParam', data)
}

const queryCustInfo = () => {
  return get('/mercWebi/mercInfo/queryInfo')
}
const queryApplyList = data => {
  return post('/mercWebi/mercInfo/queryApplyList', data)
}
//校验小程序订阅消息
const checkWxappTemplate = data => {
  return post('/mercWebi/wxAppAudit/checkWxappTemplate', data)
}
//更新小程序订阅消息
const refreshWxappTemplate = data => {
  return post('/mercWebi/wxAppAudit/refreshWxappTemplate', data)
}
//优卡列表
const queryCardList = data => {
  return post('/mercWebi/busGiftCard/queryList', data)
}

//添加
const addCard = data => {
  return post('/mercWebi/busGiftCard/add', data, {
    headers: { 'Content-Type': 'application/json' }
  })
}
//查询详情
const queryCardDetail = data => {
  return post('/mercWebi/busGiftCard/queryDetail', data)
}
// 删除优卡
const deleteCard = data => {
  return post('/mercWebi/busGiftCard/delete', data)
}
// 编辑优卡
const updateCard = data => {
  return post('/mercWebi/busGiftCard/update', data, {
    headers: { 'Content-Type': 'application/json' }
  })
}
// 优卡置顶
const busGiftCardTop = data => {
  return post('/mercWebi/busGiftCard/top', data)
}
// 优卡取消置顶
const busGiftCardCancelTop = data => {
  return post('/mercWebi/busGiftCard/cancelTop', data)
}

//店铺取送设置详情
const queryGetOrSendDetail = data => {
  return get('/storeWashSettings/detail', data)
}
const addQyNoticeRecipient = data => {
  return postJson('/mercWebi/qyNoticeRecipient/addQyNoticeRecipient', data)
}
//店铺取送设置修改
const updateGetOrSend = data => {
  return post('/storeWashSettings/update', data)
}
//店铺取送设置修改第三方下单api
const removeStoreApi = data => {
  return post('/storeWashSettings/removeApi', data)
}
//店铺取送设置列表
const queryStoreWashList = data => {
  return post('/storeWashSettings/queryList', data)
}
//店铺取送设置详情
const storeWashDetail = () => {
  return get('/storeWashSettings/detail')
}
//店铺取送设置添加
const storeWashAdd = data => {
  return post('/storeWashSettings/add', data)
}
//子账号列表
const accountList = data => {
  return geted('/storeWashSettings/account-list', data)
}
//设置公众号通知接收人
const accountNoticePerson = data => {
  return postJson('/storeWashSettings/official-account-notice-set', data)
}

//衣物管理
const washList = data => {
  return post('/mercWebi/washOrder/washList', data)
}
//衣物管理详情
const washOrder = data => {
  return post('/mercWebi/washOrder/washOrder', data)
}
//桌码列表
const getTableCodeList = data => {
  return post('/mercWebi/tableCode/getTableCodeList', data)
}
//添加桌码
const addTableCode = data => {
  return post('/mercWebi/tableCode/addTableCode', data)
}
//删除桌码
const deleteTableCodes = data => {
  return post('/mercWebi/tableCode/deleteTableCodes', data)
}
//修改桌码号
const updateTableCodeNo = data => {
  return post('/mercWebi/tableCode/updateTableCodeNo', data)
}
//桌码详情
const queryTableCodeDetails = data => {
  return get('/mercWebi/tableCode/queryTableCodeDetails', data)
}
//手动发券-根据手机号码判断是否为新用户
const queryIsNewUser = data => {
  return post('/mercWebi/userInfo/queryIsNewUser', data)
}
//根据多个手机号码查询用户信息
const queryUserByMobileNos = data => {
  return post('/mercWebi/userInfo/query-by-mobiles', data)
}
//手动发券
const manualCouponIssuance = data => {
  return post('/mercWebi/userInfo/couponIssuanceManual', data)
}
//优卡兑换码列表
const queryCradExchangeList = data => {
  return post('/mercWebi/busGiftCard/queryCradExchangeList', data)
}
//修改兑换码状态
const updateCradExchangeForStatus = data => {
  return post('/mercWebi/busGiftCard/updateCradExchangeForStatus', data)
}
//新建优卡兑换码
const addCradExchange = data => {
  return post('/mercWebi/busGiftCard/addCradExchange', data)
}
//查询管理员手机号
const administratorPhone = data => {
  return post('/mercWebi/busGiftCard/administratorPhone', data)
}
//发送管理员短信验证码
const getLoginCode = data => {
  return post('/mercWebi/busGiftCard/getLoginCode', data)
}
//管理员验证码验证
const checkCode = data => {
  return post('/mercWebi/busGiftCard/checkCode', data)
}
//新建兑换码后导出
const exportCardExchange = data => {
  return wordpost('/mercWebi/busGiftCard/exportCardExchange', data)
}
//按照条件导出
const queryCradExchangeExport = data => {
  return wordpost('/mercWebi/busGiftCard/queryCradExchangeExport', data)
}
//京东结算卡分页列表
const settleCardPage = data => {
  return get(`/express/jd/settle-card/page?businessBodyId=${data.businessBodyId}&pageSize=${data.pageSize}&startRow=${data.startRow}`)
}
//京东账号 - 查询
const getExpressConfig = data => {
  return post('/express/jd/ownAccount/getJDExpressConfigString', data)
}
//京东账号 - 添加
const expressConfigAdd = data => {
  return post('/express/jd/ownAccount/addJDExpressConfigInfo', data)
}
//京东账号 - 修改
const expressConfigUpdate = data => {
  return post('/express/jd/ownAccount/updateJDExpressConfigInfo', data)
}
//京东账号 - 详情
const expressConfigDetail = data => {
  return post('/express/jd/ownAccount/getJDExpressConfigDetailString', data)
}
//京东结算卡新建
const settleCardAdd = data => {
  return post('/express/jd/settle-card/add', data)
}
//京东结算卡详情
const settleCardDetail = data => {
  return get(`/express/jd/settle-card/detail?id=${data.id}`)
}
//京东结算卡修改
const settleCardUpdate = data => {
  return post('/express/jd/settle-card/update', data)
}
//京东结算卡冻结
const settleCardFreeze = data => {
  return post('/express/jd/settle-card/freeze', data)
}
//京东结算卡取件/送件备注修改
const settleCardRemarkUpdate = data => {
  return post('/express/jd/settle-card/remark-update', data)
}
//结算卡列表
const settleCardList = data => {
  return geted('/store-express/settle-card/list', data)
}
//京东结算卡充值-微信支付码生成
const createWXQrCode = data => {
  return post('/platform/expressParam/createWXQrCode', data)
}
//京东结算卡充值-判断是否充值成功
const queryRecordForSeq = data => {
  return post('/platform/expressParam/queryRecordForSeq', data)
}
//京东结算卡充值-创建seq
const createSeq = data => {
  return post('/platform/expressParam/createSeq', data)
}
//京东结算卡扣费记录
const queryKoufeiList = data => {
  return post('/express/jd/queryCardDeductRecord', data)
}
//京东结算卡主体列表
const queryBusinessBodyList = data => {
  return get('/express/jd/business-body/list', data)
}

//顺丰账号 - 查询
const getSfExpressConfig = data => {
  return post('/express/sf/ownAccount/getSFExpressConfigString', data)
}
//顺丰结算卡分页列表
const sfSettleCardPage = data => {
  return get(`/express/sf/settle-card/page?businessBodyId=${data.businessBodyId}&pageSize=${data.pageSize}&startRow=${data.startRow}`)
}
//顺丰结算卡主体列表
const querySfBusinessBodyList = data => {
  return get('/express/sf/business-body/list', data)
}
//顺丰账号 - 添加
const sfExpressConfigAdd = data => {
  return post('/express/sf/ownAccount/addSFExpressConfigInfo', data)
}
//顺丰结算卡新建
const sfSettleCardAdd = data => {
  return post('/express/sf/settle-card/add', data)
}
//顺丰账号 - 详情
const sfExpressConfigDetail = data => {
  return post('/express/sf/ownAccount/getSFExpressConfigDetailString', data)
}
//顺丰结算卡详情
const sfSettleCardDetail = data => {
  return get(`/express/sf/settle-card/detail?id=${data.id}`)
}
//顺丰账号 - 修改
const sfExpressConfigUpdate = data => {
  return post('/express/sf/ownAccount/updateSFExpressConfigInfo', data)
}
//顺丰结算卡取件/送件备注修改
const sfSettleCardRemarkUpdate = data => {
  return post('/express/sf/settle-card/remark-update', data)
}
//顺丰结算卡扣费记录
const querySfKoufeiList = data => {
  return post('/platform/sf/expressParam/queryCardDeductRecord', data)
}
//顺丰结算卡充值记录
const querySFRechargeList = data => {
  return post('/platform/sf/expressParam/queryRechargeList', data)
}

//查询美团授权信息
const queryMeituanInfo = data => {
  return post('/mercWebi/mercMeituanInfo/queryMeituanInfo', data)
}
//查询美团授权
const reToAuth = data => {
  return post('/dzopen/book/token', data)
}
//美团点评服务时间
const updateMeituanInfo = data => {
  return post('/mercWebi/mercMeituanInfo/updateMeituanInfo', data)
}
//快递结算卡设置
const settleCardSeting = data => {
  return post('/store-express/settle-card/setting', data)
}
//送件设置删除
const settleCardDelete = data => {
  return post('/store-express/settle-card/delete', data)
}
//京东结算卡充值-创建seq-支付宝
const createAlipayQrCode = data => {
  return post('/platform/expressParam/createAlipayQrCode', data)
}
//查询发货管理信息详情
const queryWxAuthorizerInfoDetails = data => {
  return post('/mercWebi/wxAuthorizerInfo/queryWxAuthorizerInfoDetails', data)
}
//修改发货管理信息
const updateWxAuthorizerInfo = data => {
  return post('/mercWebi/wxAuthorizerInfo/updateWxAuthorizerInfo', data)
}
//快递信息分页查询
const deliveryPage = data => {
  return post('/express/page', data)
}
// 快递信息详情
const queryExpressDetail = data => {
  return post('/express/queryExpressDetail', data)
}
// 添加请ta营销活动
const addInviteHim = data => {
  return post('/mercWebi/inviteHim/addInviteHim', data)
}
// 修改请ta营销活动
const updateInviteHim = data => {
  return post('/mercWebi/inviteHim/updateInviteHim', data)
}
// 查询请ta营销活动详情
const queryInviteDetails = data => {
  return post('/mercWebi/inviteHim/queryInviteDetails', data)
}
// 查询请ta活动列表
const queryInviteActivityList = data => {
  return post('/mercWebi/inviteHim/queryActivityList', data)
}
//京东结算卡/同城配送--充值记录--充值类型 (1京东结算卡 2同城配送)
const queryRechargeList = data => {
  return post('/platform/expressParam/queryRechargeList', data)
}
// 同城配送
// 开关
const queryCityDeliveryIsEnable = data => {
  return post('/expressWebi/cityDelivery/queryCityDeliveryIsEnable', data)
}
// 基本信息
const queryDeliveryBasicInfo = data => {
  return post('/expressWebi/cityDelivery/queryCityDeliveryStoreListByStore', data)
}
// 修改
const updateDeliveryInfo = data => {
  return post('/expressWebi/cityDelivery/updateCityDeliveryStoreInfo', data)
}
// 排序
const deliverySort = data => {
  return post('/expressWebi/cityDelivery/updateCityDeliveryStoreSort', data)
}
//充值-创建Seq
const cityCreateSeq = data => {
  return post('/expressWebi/cityDelivery/createSeq', data)
}
//充值-微信支付码生成
const cityCreateWXQrCode = data => {
  return post('/expressWebi/cityDelivery/createWXQrCode', data)
}
//充值-支付宝支付码生成
const cityCreateAlipayQrCode = data => {
  return post('/expressWebi/cityDelivery/createAlipayQrCode', data)
}
//充值-判断是否充值成功
const cityQueryRecordForSeq = data => {
  return post('/expressWebi/cityDelivery/queryRecordForSeq', data)
}
// 扣费记录查询
const getDeductionRecordsList = data => {
  return post('/expressWebi/cityDelivery/getDeductionRecordsList', data)
}
// 列表
const getPromoCodeInfoList = data => {
  return post('/mercWebi/promoCode/getPromoCodeInfoList', data)
}
// 新建
const addPromoCodeInfo = data => {
  return post('/mercWebi/promoCode/addPromoCodeInfo', data)
}
// 修改
const updatePromoCodeInfo = data => {
  return post('/mercWebi/promoCode/updatePromoCodeInfo', data)
}
// 详情
const getPromoCodeDetail = data => {
  return post('/mercWebi/promoCode/getPromoCodeDetail', data)
}
// 添加兑换密钥
const addExchangeSecreKey = data => {
  return post('/mercWebi/promoCode/addExchangeSecreKey', data)
}
// 兑换密钥列表
const getPromoCodeExchangeList = data => {
  return post('/mercWebi/promoCode/getPromoCodeExchangeList', data)
}
// 兑换密钥-修改状态
const updateExchangeStatus = data => {
  return post('/mercWebi/promoCode/updateExchangeStatus', data)
}
// 兑换密钥-进行打标签
const addExchangeLabel = data => {
  return post('/mercWebi/promoCode/addExchangeLabel', data)
}
// 兑换密钥-删除标签
const deleteExchangeLabel = data => {
  return post('/mercWebi/promoCode/deleteExchangeLabel', data)
}
// 优惠码-新建后导出
const exportPromoExchange = data => {
  return wordpost('/mercWebi/promoCode/exportPromoExchange', data)
}
//按照条件导出
const exportPromoExchangeByParams = data => {
  return wordpost('/mercWebi/promoCode/exportPromoExchangeByParams', data)
}
// 小程序自定义菜单 - add
const addCustomMenu = data => {
  return postJson('/mercWebi/customMenu/addCustomMenu', data)
}
// 小程序自定义菜单 - del
const delCustomMenu = data => {
  return post('/mercWebi/customMenu/delCustomMenu', data)
}
// 小程序自定义菜单 - del
const queryCustomMenu = data => {
  return post('/mercWebi/customMenu/queryCustomMenu', data)
}

// 设置取件时间方案
const modifyMercDyTime = data => {
  return post('/mercWebi/dy/modifyMercDy', data)
}
// 查询商家取件时间方案
const queryMercDyTime = data => {
  return post('/mercWebi/dy/queryMercDy', data)
}
// 设置抖音商家参数
const modifyMercDyConfig = data => {
  return post('/mercWebi/dy/modifyMercDyConfig', data)
}

// 查询抖音团购商品列表
const queryMercDyGroupBuying = data => {
  return post('/mercWebi/dy/restrict/page', data)
}
// 创建抖音团购商品
const createMercDyGroupBuying = data => {
  return post('/mercWebi/dy/restrict/create', data)
}
// 更新抖音团购商品
const updateMercDyGroupBuying = data => {
  return post('/mercWebi/dy/restrict/update', data)
}
// 删除抖音团购商品
const deleteMercDyGroupBuying = data => {
  return post('/mercWebi/dy/restrict/delete', data)
}

// 家政功能-详情
const getHomemakingSettings = data => {
  return get(`/mercWebi/storeHomemakingSettings/detail/${data}`)
}

// 家政功能-修改
const updateHomemakingSettings = data => {
  return post('/mercWebi/storeHomemakingSettings/update', data)
}

// 家政功能-新增
const addHomemakingSettings = data => {
  return post('/mercWebi/storeHomemakingSettings/add', data)
}

// 家政功能-设置通知接收人
const setHomemakingOfficialPerson = data => {
  return postJson('/mercWebi/storeHomemakingSettings/official-account-notice-set', data)
}

// 家政功能-设置通知子账号列表
const getHomemakingAccountList = data => {
  return geted('/mercWebi/storeHomemakingSettings/account-list', data)
}

// 分销-团长列表
const queryLeaderList = data => {
  return post('/mercWebi/teamLeader/queryLeaderList', data)
}

// 分销-团队/用户人数
const queryGroupMemberList = data => {
  return post('/mercWebi/teamLeader/queryGroupMemberList', data)
}

// 分销-添加上级
const addLeader = data => {
  return post('/mercWebi/teamLeader/addLeader', data)
}

// 分销-移除上级
const delLeader = data => {
  return post('/mercWebi/teamLeader/delLeader', data)
}

// 分销-解除关系
const removeLeader = data => {
  return post('/mercWebi/teamLeader/removeLeader', data)
}

// 分销-分佣列表
const queryOrderCommission = data => {
  return post('/mercWebi/teamLeader/queryOrderCommission', data)
}

// 分销-设置
const getDistributionParam = data => {
  return post('/mercWebi/mercInfo/getDistributionParam', data)
}

// 分销-设置
const saveDistributionParam = data => {
  return post('/mercWebi/mercInfo/saveDistributionParam', data)
}

// 分销-修改团长分佣比例
const modifyCommission = data => {
  return post('/mercWebi/teamLeader/modifyCommission', data)
}

// 分销-修改商品分佣过期时间
const modifyCommissionExpireDate = data => {
  return post('/mercWebi/teamLeader/modifyCommissionExpireDate', data)
}

// 分销-团长与下级列表
const queryLeaderRelList = data => {
  return post('/mercWebi/teamLeader/queryLeaderRelList', data)
}

// 分销-修改团长归属团体单位
const editLeaderRelTeamUnit = data => {
  return post('/mercWebi/teamLeader/editTeamUnit', data)
}

// 应用-保险列表
const getInsureInfoList = data => {
  return postJson('/ext/insureInfo/list', data)
}

// 应用-保险详情
const getInsureInfoDetail = data => {
  return postJson('/ext/insureInfo/detail', data)
}

// 配单-店铺配单衣物列表
const getFindorderList = data => {
  return post('/mercWebi/findorder/getFindorderList', data)
}

// 团体单位-分页列表
const getTeamUnitList = data => {
  return post('/mercWebi/teamUnit/listTeamUnit', data)
}
// 团体单位-下拉列表
const getTeamUnitSelectList = data => {
  return post('/mercWebi/teamUnit/listTeamUnitNotPage', data)
}
// 团体单位-添加，编辑
const saveTeamUnit = data => {
  return post('/mercWebi/teamUnit/saveTeamUnit', data)
}
// 团体单位-详情
const getTeamUnitDetail = data => {
  return post('/mercWebi/teamUnit/queryTeamUnit', data)
}
// 团体单位-删除
const deleteTeamUnit = data => {
  return post('/mercWebi/teamUnit/deleteTeamUnit', data)
}
// 团体单位-单位分组编辑，添加
const saveTeamUnitGroup = data => {
  return post('/mercWebi/teamUser/saveTeamUnitGroup', data)
}
// 团体单位-单位分组
const getListTeamUnitGroup = data => {
  return post('/mercWebi/teamUser/listTeamUnitGroup', data)
}
// 团体单位-删除单位分组
const deleteGroupById = data => {
  return post('/mercWebi/teamUser/deleteGroupById', data)
}
// 团体单位-分组排序
const sortTeamUnitGroup = data => {
  return post('/mercWebi/teamUser/sortTeamUnitGroup', data)
}
// 团体单位-分组用户
const getListGroupUser = data => {
  return post('/mercWebi/teamUser/listGroupUser', data)
}
// 团体单位-添加分组用户
const addGroupUser = data => {
  return post('/mercWebi/teamUser/addGroupUser', data)
}
// 团体单位-编辑分组用户
const editGroupUser = data => {
  return post('/mercWebi/teamUser/editGroupUser', data)
}
// 团体单位-删除分组用户
const deleteGroupUser = data => {
  return post('/mercWebi/teamUser/deleteGroupUser', data)
}

// 智能设备
const querySmartDevice = data => {
  return post('/mercWebi/busStoreInfo/querySmartDevice', data)
}
// 智能设备-列表
const querySmartDeviceList = data => {
  return post('/mercWebi/smartDevice/listByPage', data)
}
// 智能设备-详情
const smartDeviceDetail = data => {
  return post('/mercWebi/smartDevice/smartDeviceDetail', data)
}
// 智能设备-刷新设备状态
const refreshDeviceStatus = data => {
  return post('/mercWebi/smartDevice/refreshStatus', data)
}
// 智能设备-发送指令
const optSmartDevice = data => {
  return post('/mercWebi/smartDevice/optRobot', data)
}
// 智能设备-添加设备图片
const saveDeviceImages = data => {
  return post('/mercWebi/smartDevice/saveDeviceImages', data)
}
// 智能设备-删除设备图片
const deleteDeviceImage = data => {
  return post('/mercWebi/smartDevice/deleteDeviceImage', data)
}
// 智能设备-设备图片排序
const deviceImageSort = data => {
  return post('/mercWebi/smartDevice/deviceImageSort', data)
}
// 智能设备-修改设备袋子数量
const updateRoadBagNum = data => {
  return post('/mercWebi/smartDevice/updateRoadBagNum', data)
}
// 智能设备-语音设置
const updateVoiceSetting = data => {
  return post('/mercWebi/smartDevice/updateVoiceSetting', data)
}
// 智能设备-查询语音设置
const getVoiceSettingList = data => {
  return post('/mercWebi/smartDevice/findVoiceSettingList', data)
}

// 会话记录列表
const queryChatLogList = data => {
  return post('/mercWebi/chatLog/queryList', data)
}

// 会话记录详情
const queryChatLogDetail = data => {
  return post('/mercWebi/chatLog/queryDetail', data)
}

// 抖音商品列表
const queryDyListPage = data => {
  return post('/mercWebi/dy/goods/queryListPage', data)
}
// 抖音商品新增
const insertThirdGroupInfo = data => {
  return post('/mercWebi/dy/goods/insertThirdGroupInfo', data)
}
// 抖音商品编辑
const updateThirdGroupInfo = data => {
  return post('/mercWebi/dy/goods/updateThirdGroupInfo', data)
}
// 抖音商品品类
const queryCategoryList = data => {
  return post('/mercWebi/dy/goods/queryCategoryList', data)
}
// 抖音适用门店
const queryDyStoreList = data => {
  return post('/mercWebi/dy/goods/queryDyStoreList', data)
}
// 抖音商品查询
const queryDyDetail = data => {
  return post('/mercWebi/dy/goods/queryDetailById', data)
}
// 抖音商品上下架
const operateDyGoods = data => {
  return post('/mercWebi/dy/goods/operate', data)
}
// 抖音商品删除
const deleteDyGoods = data => {
  return post('/mercWebi/dy/goods/deleteAllThirdGroupInfoById', data)
}
// 抖音商品排序
const sortDyGoods = data => {
  return post('/mercWebi/dy/goods/modifyThirdGroupSort', data)
}
// 抖音商品同步
const synchronousDyGoods = data => {
  return post('/mercWebi/dy/goods/syncGoods', data)
}
// 抖音商品列表统计
const getDyGoodsCount = data => {
  return post('/mercWebi/dy/goods/countStatusList', data)
}
// 抖音商品适用店铺
const getDyStoreList = data => {
  return post('/mercWebi/dy/goods/countDyStoreList', data)
}

// 店铺伙伴-列表
const getStorePartnerList = data => {
  return post('/mercWebi/storePartner/getStorePartnerList', data)
}
// 店铺伙伴-新增
const addStorePartner = data => {
  return post('/mercWebi/storePartner/addStorePartner', data)
}
// 店铺伙伴-分佣记录
const partnerCommissionList = data => {
  return post('/mercWebi/storePartner/partnerCommissionList', data)
}
// 店铺伙伴-启用/禁用
const enableStorePartner = data => {
  return post('/mercWebi/storePartner/enableStorePartner', data)
}
// 店铺伙伴-查询商家伙伴
const getMercPartner = data => {
  return post('/mercWebi/storePartner/getMercPartner', data)
}
// 店铺伙伴-绑定新伙伴
const bindStorePartner = data => {
  return post('/mercWebi/storePartner/bindStorePartner', data)
}
// 店铺伙伴-修改分佣
const updateStorePartner = data => {
  return post('/mercWebi/storePartner/updateStorePartner', data)
}
// 店铺伙伴-店铺伙伴列表(不分页)
const getListByStoreId = data => {
  return post('/mercWebi/storePartner/getListByStoreId', data)
}
// 店铺伙伴-移除店铺伙伴
const deleteStorePartner = data => {
  return post('/mercWebi/storePartner/deleteStorePartner', data)
}

// 营销活动-消费赠券列表
const consumeCouponRuleList = data => {
  return postJson('/mercWebi/consumeCouponRule/queryList', data)
}
// 营销活动-消费赠券添加
const consumeCouponRuleSave = data => {
  return postJson('/mercWebi/consumeCouponRule/saveRule', data)
}
// 营销活动-消费赠券启用/停用
const consumeCouponRuleStatus = data => {
  return postJson('/mercWebi/consumeCouponRule/updateStatus', data)
}
// 营销活动-消费赠券详情
const consumeCouponRuleDetail = data => {
  return get(`/mercWebi/consumeCouponRule/queryDetail/${data.id}`)
}
// 营销活动-消费赠券删除
const consumeCouponRuleDelete = data => {
  return get(`/mercWebi/consumeCouponRule/deleteRule/${data.id}`)
}

// 洗衣码-批次新建/编辑
const saveWashCode = data => {
  return post(`/mercWebi/washCode/save`, data)
}
// 洗衣码-批次列表
const getWashCodeList = data => {
  return post(`/mercWebi/washCode/listByPage`, data)
}
// 洗衣码-批次详情
const getWashCodeDetail = data => {
  return post(`/mercWebi/washCode/batchDetail`, data)
}
// 洗衣码-批次状态修改
const updateWashCodeStatus = data => {
  return post(`/mercWebi/washCode/updateCodeStatus`, data)
}

// 取送-到店 服务管家列表
const queryServiceButler = data => {
  return post(`/mercWebi/webAccountInfo/queryServiceButler`, data)
}

// api下单-配置列表
const apiPlaceOrderConfigList = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/apiPlaceOrderConfigList`, data)
}
// api下单-配置列表
const saveApiPlaceOrderConfig = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/saveApiPlaceOrderConfig`, data)
}
// api下单-配置列表
const apiPlaceOrderConfigDetail = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/apiPlaceOrderConfigDetail`, data)
}
// api下单-已绑定的店铺列表
const queryBindApiStoreList = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/queryBindApiStoreList`, data)
}
// api下单-未绑定的店铺列表
const queryNotBindApiStoreList = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/queryNotBindApiStoreList`, data)
}
// api下单-批量绑定店铺
const batchBindApi = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/batchBindApi`, data)
}
// api下单-移除绑定店铺
const removeAllStoreApi = data => {
  return post(`/mercWebi/apiPlaceOrderConfig/removeAllStore`, data)
}

// 云打印-保存打印机信息
const saveCloudPrinter = data => {
  return post(`/mercWebi/cloudPrinter/savePrinter`, data)
}
// 云打印-打印配置列表
const getCloudPrinterList = data => {
  return post(`/mercWebi/cloudPrinter/printerList`, data)
}
// 云打印-删除打印配置
const deleteCloudPrinter = data => {
  return post(`/mercWebi/cloudPrinter/deletePrinter`, data)
}
// 云打印-修改关联店铺
const updateCloudPrinterStore = data => {
  return post(`/mercWebi/cloudPrinter/updatePrinterStore`, data)
}
// 云打印-修改关联商品
const updateCloudPrinterGoods = data => {
  return post(`/mercWebi/cloudPrinter/updatePrinterGoods`, data)
}
// 云打印-查询打印机关联店铺
const queryPrinterStoreList = data => {
  return post(`/mercWebi/cloudPrinter/queryPrinterStoreList`, data)
}
// 云打印-查询打印机关联商品
const queryPrinterGoodsList = data => {
  return post(`/mercWebi/cloudPrinter/queryPrinterGoodsList`, data)
}



export default {
  inviteeList,
  participantList,
  participantStatistic,
  authType,
  goDetail,
  wxAuthorizerInfobind,
  wxAuthorizerInfodetail,
  wxAuthorizerInfotoBind,
  getUnbindCode,
  unbind,
  submitAudit,
  checkAudit,
  release,
  queryCnt,
  querySmsList,
  smsSettingListByPage,
  updateSmsSetting,
  queryDelivery,
  updateDelivery,
  queryRegionList,
  delRegion,
  addRegion,
  queryCouponList,
  addCoupon,
  queryCouponDetail,
  editCoupon,
  addActivity,
  queryActivityList,
  updateActivity,
  queryActivityDetail,
  updateStatus,
  updateCouponStatus,
  queryCount,
  queryPack,
  addPack,
  updatePack,
  addPackStatus,
  PackageDetail,
  cancellationUserCoupon,
  addWorker,
  queryWorkerList,
  sysWorkerList,
  delWorker,
  addMercActivity,
  selectStoreList,
  VersionList,
  listPartakeInfo,
  listClusterInfo,
  insertPartake,
  partakeDetail,
  updatePartake,
  countPartakeInfo,
  countClusterInfo,
  listAdvertise,
  insertAdvertise,
  modifyAdvertise,
  modifyStatus,
  listStoreByStationId,
  deleteAdvertise,
  listAdvertisePosition,
  advertiseDetail,
  moveAdvertise,
  updateWxappParam,
  queryCustInfo,
  queryApplyList,
  checkWxappTemplate,
  refreshWxappTemplate,
  queryCardList,
  addCard,
  queryCardDetail,
  deleteCard,
  updateCard,
  busGiftCardTop,
  busGiftCardCancelTop,
  queryGetOrSendDetail,
  addQyNoticeRecipient,
  updateGetOrSend,
  removeStoreApi,
  queryStoreWashList,
  storeWashDetail,
  storeWashAdd,
  accountNoticePerson,
  accountList,
  washList,
  washOrder,
  getTableCodeList,
  addTableCode,
  deleteTableCodes,
  updateTableCodeNo,
  queryTableCodeDetails,
  queryIsNewUser,
  queryUserByMobileNos,
  manualCouponIssuance,
  queryCradExchangeList,
  updateCradExchangeForStatus,
  addCradExchange,
  administratorPhone,
  getLoginCode,
  checkCode,
  exportCardExchange,
  queryCradExchangeExport,
  settleCardPage,
  settleCardAdd,
  settleCardDetail,
  settleCardUpdate,
  settleCardRemarkUpdate,
  settleCardFreeze,
  queryRechargeList,
  createWXQrCode,
  queryRecordForSeq,
  createSeq,
  queryKoufeiList,
  queryMeituanInfo,
  settleCardList,
  settleCardSeting,
  settleCardDelete,
  reToAuth,
  updateMeituanInfo,
  createAlipayQrCode,
  queryWxAuthorizerInfoDetails,
  updateWxAuthorizerInfo,
  deliveryPage,
  queryExpressDetail,
  addInviteHim,
  updateInviteHim,
  queryInviteDetails,
  queryInviteActivityList,
  getExpressConfig,
  expressConfigAdd,
  expressConfigUpdate,
  expressConfigDetail,
  queryCityDeliveryIsEnable,
  queryDeliveryBasicInfo,
  updateDeliveryInfo,
  deliverySort,
  getDeductionRecordsList,
  getPromoCodeInfoList,
  addPromoCodeInfo,
  updatePromoCodeInfo,
  getPromoCodeDetail,
  addExchangeSecreKey,
  getPromoCodeExchangeList,
  updateExchangeStatus,
  addExchangeLabel,
  deleteExchangeLabel,
  exportPromoExchange,
  exportPromoExchangeByParams,
  queryCustomMenu,
  addCustomMenu,
  delCustomMenu,
  cityCreateSeq,
  cityCreateWXQrCode,
  cityCreateAlipayQrCode,
  cityQueryRecordForSeq,
  queryBusinessBodyList,
  getSfExpressConfig,
  sfSettleCardPage,
  querySfBusinessBodyList,
  sfExpressConfigAdd,
  sfSettleCardAdd,
  sfExpressConfigDetail,
  sfSettleCardDetail,
  sfExpressConfigUpdate,
  sfSettleCardRemarkUpdate,
  querySfKoufeiList,
  querySFRechargeList,
  modifyMercDyTime,
  queryMercDyTime,
  modifyMercDyConfig,
  queryMercDyGroupBuying,
  createMercDyGroupBuying,
  updateMercDyGroupBuying,
  deleteMercDyGroupBuying,
  getHomemakingSettings,
  updateHomemakingSettings,
  addHomemakingSettings,
  setHomemakingOfficialPerson,
  getHomemakingAccountList,
  queryLeaderList,
  queryGroupMemberList,
  addLeader,
  delLeader,
  removeLeader,
  queryOrderCommission,
  getDistributionParam,
  saveDistributionParam,
  modifyCommission,
  modifyCommissionExpireDate,
  queryLeaderRelList,
  editLeaderRelTeamUnit,
  getInsureInfoList,
  getInsureInfoDetail,
  getFindorderList,
  getTeamUnitList,
  getTeamUnitSelectList,
  saveTeamUnit,
  getTeamUnitDetail,
  deleteTeamUnit,
  saveTeamUnitGroup,
  getListTeamUnitGroup,
  deleteGroupById,
  sortTeamUnitGroup,
  getListGroupUser,
  addGroupUser,
  editGroupUser,
  deleteGroupUser,
  querySmartDevice,
  querySmartDeviceList,
  smartDeviceDetail,
  refreshDeviceStatus,
  optSmartDevice,
  saveDeviceImages,
  deleteDeviceImage,
  deviceImageSort,
  updateRoadBagNum,
  updateVoiceSetting,
  getVoiceSettingList,
  queryChatLogList,
  queryChatLogDetail,
  queryDyListPage,
  insertThirdGroupInfo,
  updateThirdGroupInfo,
  queryCategoryList,
  queryDyStoreList,
  queryDyDetail,
  operateDyGoods,
  deleteDyGoods,
  sortDyGoods,
  synchronousDyGoods,
  getDyGoodsCount,
  getDyStoreList,
  getStorePartnerList,
  addStorePartner,
  partnerCommissionList,
  enableStorePartner,
  getMercPartner,
  bindStorePartner,
  updateStorePartner,
  getListByStoreId,
  deleteStorePartner,
  consumeCouponRuleList,
  consumeCouponRuleSave,
  consumeCouponRuleStatus,
  consumeCouponRuleDetail,
  consumeCouponRuleDelete,
  saveWashCode,
  getWashCodeList,
  getWashCodeDetail,
  updateWashCodeStatus,
  queryServiceButler,
  apiPlaceOrderConfigList,
  saveApiPlaceOrderConfig,
  apiPlaceOrderConfigDetail,
  queryBindApiStoreList,
  queryNotBindApiStoreList,
  batchBindApi,
  removeAllStoreApi,
  saveCloudPrinter,
  getCloudPrinterList,
  deleteCloudPrinter,
  updateCloudPrinterStore,
  updateCloudPrinterGoods,
  queryPrinterStoreList,
  queryPrinterGoodsList
}
